import React from 'react';
import Link from 'gatsby-link';
import Img from 'gatsby-image';
import Scroll from '../components/Scroll';
import TeamMember from '../components/TeamMember';
import Hero from '../components/Hero';
import SEO from '../components/SEO';

const SiteData = {
  title: 'O nas',
  slug: '/o-nas',
  description:
    'LUK & LUK Auto Serwis - Niezależny Serwis BMW istnieje w Raciborzu od 2003 roku. Na początku jego istnienia skupiał się na naprawie samochodów różnych marek ze specjalnością marki BMW.',
};

export default ({ data }) => (
  <div>
    <SEO isSeo siteData={SiteData} type="Local Business" />
    <div className="theme-page">
      <Hero image={data.aboutHero.sizes} heading="Nasza historia i zespół">
        <div className=" margin-top-67 padding-bottom-20">
          <Scroll type="id" element="team">
            <a className="more" title="POZNAJ NAS BLIŻEJ">
              <span>poznaj nas bliżej</span>
            </a>
          </Scroll>
        </div>
      </Hero>
      <div id="team" className="row gray full-width page-header vertical-align-table">
        <div className="row full-width padding-top-bottom-50 vertical-align-cell">
          <div className="row">
            <div className="page-header-left">
              <h1>O nas</h1>
            </div>
            <div className="page-header-right">
              <div className="bread-crumb-container">
                <label>JESTEŚ TUTAJ:</label>
                <ul className="bread-crumb">
                  <li>
                    <Link to="/">STRONA GŁÓWNA</Link>
                  </li>
                  <li className="separator">&#47;</li>
                  <li>O NAS</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="clearfix">
        <div className="row margin-top-70">
          <div className="column column-1-2">
            <p className="description margin-top-0">
              LUK & LUK Auto Serwis - Niezależny Serwis BMW istnieje w Raciborzu od 2003 roku. Na początku jego
              istnienia skupiał się na naprawie samochodów różnych marek ze specjalnością marki BMW.
            </p>
            <p className="margin-top-10">
              W miarę upływu czasu klienci z samochodami marki BMW stanowili coraz większy udział procentowy serwisu, co
              spowodowało skupienie się serwisu na naprawie pojazdów tylko tego producenta.
              <br />
              <br />
              Jako niezależny serwis BMW świadczymy bardzo szeroki zakres usług. Począwszy od okresowych przeglądów,
              wymiany opon i mechaniki, po kodowanie, zaawansowaną diagnostykę i naprawy powypadkowe. <br />
              Posiadamy specjalistyczny sprzęt, który w połączeniu z doświadczeniem i szeroką wiedzą pozwala szybko i w
              pełni zdiagnozować usterkę i rozwiązać problemy. <br />
              <br />
              Nasze usługi cechuje wysoka jakość, solidność oraz uczciwość. Klienta traktujemy priorytetowo a ich
              samochody z odpowiednią dbałością.
            </p>
            <h4 className="box-header margin-top-26">DLACZEGO LUK & LUK?</h4>
            <ul className="list margin-top-30">
              <li className="template-bullet">Otwartość i transparentnosć w relacjach z klientami</li>
              <li className="template-bullet">Szybkie i precyzyjne diagnozy usterek</li>
              <li className="template-bullet">Fachowa wiedza potwierdzona licznymi certyfikatami</li>
              <li className="template-bullet">Każdy członek zespołu to prawdziwy fanatyk BMW 😁</li>
              <li className="template-bullet">Terminowość w naprawach</li>
            </ul>
            <div className="page-margin-top mobile-center">
              <Link to="/uslugi" className="more">
                <span>zobacz ofertę</span>
              </Link>
            </div>
          </div>
          <div className="column column-1-2">
            <Img sizes={data.aboutGallery_01.sizes} imgStyle={{ objectPosition: '0 0' }} style={{ width: '100%' }} />
            <div className="row margin-top-30">
              <div className="column column-1-2">
                <Img
                  sizes={data.aboutGallery_02.sizes}
                  imgStyle={{ objectPosition: '0 0' }}
                  style={{ width: '100%' }}
                />
              </div>
              <div className="column column-1-2">
                <Img
                  sizes={data.aboutGallery_03.sizes}
                  imgStyle={{ objectPosition: '0 0' }}
                  style={{ width: '100%' }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row gray full-width page-margin-top-section page-padding-top padding-bottom-66">
          <div className="row">
            <div className="column column-1-4 align-center">
              <span className="number sign">99.9%</span>
              <h5 className="margin-top-10">
                ZADOWOLENIA<br />KLIENTA
              </h5>
            </div>
            <div className="column column-1-4 align-center">
              <span className="number sign">99.9%</span>
              <h5 className="margin-top-10">RZETELNOŚCI</h5>
            </div>
            <div className="column column-1-4 align-center">
              <span className="number sign">99.9%</span>
              <h5 className="margin-top-10">
                NAPRAWIONYCH<br />BMW
              </h5>
            </div>
            <div className="column column-1-4 align-center">
              <span className="number sign">99.9%</span>
              <h5 className="margin-top-10">JAKOŚCI</h5>
            </div>
          </div>
        </div>
        <div className="row page-margin-top-section padding-bottom-66">
          <div className="row">
            <h2 className="box-header">NASZ ZESPÓŁ</h2>
            <p className="description align-center">Poznaj każdego z członków naszego zespołu.</p>
          </div>
          <div className="team">
            {data.team.edges.map(member => {
              const { photo } = member.node;
              return <TeamMember key={member.node.name} data={member.node} sizes={data[photo].sizes} />;
            })}
          </div>
        </div>
        <div className="row gray full-width padding-top-54 padding-bottom-61 align-center">
          <h3 style={{ lineHeight: 2.5 }}>
            <span className="button-label">CHCESZ Z NAMI WSPÓŁPRACOWAĆ LUB MASZ JAKIEŚ PYTANIA?</span>{' '}
            <Link className="more" to="/kontakt" style={{ display: 'inline-block' }}>
              <span>skontaktuj się</span>
            </Link>
          </h3>
        </div>
      </div>
    </div>
  </div>
);

export const query = graphql`
  query AboutPage {
    team: allTeamDataJson {
      edges {
        node {
          name
          type
          description
          photo
          left
        }
      }
    }
    aboutHero: imageSharp(id: { regex: "/aboutHero/" }) {
      sizes(maxWidth: 1900, maxHeight: 900) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    aboutGallery_01: imageSharp(id: { regex: "/aboutGallery_01/" }) {
      sizes(maxWidth: 600) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    aboutGallery_02: imageSharp(id: { regex: "/aboutGallery_02/" }) {
      sizes(maxWidth: 300) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    aboutGallery_03: imageSharp(id: { regex: "/aboutGallery_03/" }) {
      sizes(maxWidth: 300) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    aboutMember_01: imageSharp(id: { regex: "/aboutMember_01/" }) {
      sizes(maxWidth: 600) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    aboutMember_02: imageSharp(id: { regex: "/aboutMember_02/" }) {
      sizes(maxWidth: 600) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    aboutMember_03: imageSharp(id: { regex: "/aboutMember_03/" }) {
      sizes(maxWidth: 600) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    aboutMember_04: imageSharp(id: { regex: "/aboutMember_04/" }) {
      sizes(maxWidth: 600) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    aboutMember_05: imageSharp(id: { regex: "/aboutMember_05/" }) {
      sizes(maxWidth: 600) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    aboutMember_06: imageSharp(id: { regex: "/aboutMember_06/" }) {
      sizes(maxWidth: 600) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    aboutMember_07: imageSharp(id: { regex: "/aboutMember_07/" }) {
      sizes(maxWidth: 600) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    aboutMember_08: imageSharp(id: { regex: "/aboutMember_08/" }) {
      sizes(maxWidth: 600) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    aboutMember_09: imageSharp(id: { regex: "/aboutMember_09/" }) {
      sizes(maxWidth: 600) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    aboutMember_10: imageSharp(id: { regex: "/aboutMember_10/" }) {
      sizes(maxWidth: 600) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    aboutMember_11: imageSharp(id: { regex: "/aboutMember_11/" }) {
      sizes(maxWidth: 600) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    aboutMember_12: imageSharp(id: { regex: "/aboutMember_12/" }) {
      sizes(maxWidth: 600) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    aboutMember_13: imageSharp(id: { regex: "/aboutMember_13/" }) {
      sizes(maxWidth: 600) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    aboutMember_14: imageSharp(id: { regex: "/aboutMember_14/" }) {
      sizes(maxWidth: 600) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    aboutMember_15: imageSharp(id: { regex: "/aboutMember_15/" }) {
      sizes(maxWidth: 600) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/o-nas.js